// Canonical list of neighborhood parks in the Easton Park area.
// Keep this list in one place so the ListItem form and the EditListingModal
// stay in sync. Add new parks here.
export const PARKS = [
    "Ariza Easton Park",
    "BB Living Easton Park",
    "Bryant Park",
    "Discovery Park",
    "Elina",
    "Kieke Park",
    "Knob Hill Park",
    "Pilot Park",
    "Prospect Park",
    "Skyline Park",
    "Union Park East",
    "Union Park West",
    "Wixby House",
];

export const PARK_OTHER = "Other";
